import ApiService from './ApiService';
import { ApiPath } from './enums/ApiPath';
import { SpecialReportsGroupsDto } from '../../special-reports/interfaces/SpecialReportsGroupsDto';

export class SpecialReportsApiService {
  static getGroups(): Promise<SpecialReportsGroupsDto> {
    return ApiService.get<SpecialReportsGroupsDto>(ApiPath.SpecialReports);
  }
}
